import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "../i18n/LanguageContext";

const SITE_URL = "https://www.velocitas.bg";
const OG_IMAGE =
  "https://customer-assets.emergentagent.com/job_startup-growth-4/artifacts/7qtdvjf0_lucid-origin_a_modern_business_accelerator_company_having_office_in_a_sleek_glass_and_steel_s-0.jpg";

const META_BY_PAGE = {
  home: {
    bg: {
      title: "Velocitas — Бизнес акселератор за български МСП",
      description:
        "Velocitas Growth Lab — шестмесечна стратегическа програма за утвърдени български МСП с приходи €250к–€750к. Структуриран растеж, финансова дисциплина, дългосрочно партньорство.",
      ogTitle: "Velocitas — Бизнес акселератор за български МСП",
      ogDescription:
        "Шестмесечна стратегическа програма за утвърдени български МСП. Структуриран растеж. Дългосрочно партньорство.",
    },
    en: {
      title: "Velocitas — Business Accelerator for Bulgarian SMEs",
      description:
        "Velocitas Growth Lab — a six-month strategic program for established Bulgarian SMEs generating €250k–€750k. Structured growth, financial discipline, long-term alignment.",
      ogTitle: "Velocitas — Business Accelerator for Bulgarian SMEs",
      ogDescription:
        "A six-month strategic program for established Bulgarian SMEs. Structure first. Speed follows.",
    },
  },
  privacy: {
    bg: {
      title: "Политика за поверителност · Velocitas",
      description:
        "Политика за поверителност на Mountain Gem Investment LLC. Как събираме, обработваме и защитаваме личните ви данни.",
      ogTitle: "Политика за поверителност · Velocitas",
      ogDescription:
        "Как събираме, обработваме и защитаваме личните ви данни.",
    },
    en: {
      title: "Privacy Policy · Velocitas",
      description:
        "Mountain Gem Investment LLC Privacy Policy. How we collect, process and protect your personal data.",
      ogTitle: "Privacy Policy · Velocitas",
      ogDescription:
        "How we collect, process and protect your personal data.",
    },
  },
};

const setMeta = (selector, attr, value) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

const SEO = () => {
  const { lang } = useLang();
  const location = useLocation();

  useEffect(() => {
    const pageKey = location.pathname === "/privacy" ? "privacy" : "home";
    const meta = META_BY_PAGE[pageKey][lang];
    const path = location.pathname === "/privacy" ? "/privacy" : "/";
    const canonical = `${SITE_URL}${path}`;

    document.title = meta.title;
    document.documentElement.lang = lang;

    setMeta('meta[name="description"]', "content", meta.description);

    setMeta('meta[property="og:title"]', "content", meta.ogTitle);
    setMeta('meta[property="og:description"]', "content", meta.ogDescription);
    setMeta('meta[property="og:url"]', "content", canonical);
    setMeta('meta[property="og:image"]', "content", OG_IMAGE);
    setMeta(
      'meta[property="og:locale"]',
      "content",
      lang === "bg" ? "bg_BG" : "en_US",
    );
    setMeta(
      'meta[property="og:locale:alternate"]',
      "content",
      lang === "bg" ? "en_US" : "bg_BG",
    );

    setMeta('meta[name="twitter:title"]', "content", meta.ogTitle);
    setMeta('meta[name="twitter:description"]', "content", meta.ogDescription);
    setMeta('meta[name="twitter:image"]', "content", OG_IMAGE);

    let canonicalLink = document.head.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute("href", canonical);

    // Block indexing of non-production hosts (e.g. emergent preview, localhost).
    // Only the canonical production domain (www.velocitas.bg) should appear in
    // Google search results.
    // Skip this override during the build-time pre-render pass (see
    // scripts/prerender.js) so the baked HTML keeps the production-friendly
    // defaults from index.html.
    const ua =
      typeof navigator !== "undefined" ? navigator.userAgent || "" : "";
    const isPrerender = ua.includes("VelocitasPrerender");
    const hostname =
      typeof window !== "undefined" ? window.location.hostname : "";
    const isProductionHost =
      hostname === "velocitas.bg" || hostname === "www.velocitas.bg";

    if (!isPrerender) {
      let robotsMeta = document.head.querySelector('meta[name="robots"]');
      if (!robotsMeta) {
        robotsMeta = document.createElement("meta");
        robotsMeta.setAttribute("name", "robots");
        document.head.appendChild(robotsMeta);
      }
      robotsMeta.setAttribute(
        "content",
        isProductionHost ? "index, follow" : "noindex, nofollow",
      );

      let googlebotMeta = document.head.querySelector('meta[name="googlebot"]');
      if (!googlebotMeta) {
        googlebotMeta = document.createElement("meta");
        googlebotMeta.setAttribute("name", "googlebot");
        document.head.appendChild(googlebotMeta);
      }
      googlebotMeta.setAttribute(
        "content",
        isProductionHost ? "index, follow" : "noindex, nofollow",
      );
    }
  }, [lang, location.pathname]);

  return null;
};

export default SEO;
